import { getCurationsCheckLimit } from '@musinsa/apis-curator';
import {
  lazyPipe,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { CheckCurationCreatableServiceResponse } from './check-curation-creatable.dto';
import { CheckCurationCreatableServiceResponseSchema } from './check-curation-creatable.dto';

export const checkCurationCreatableService = withServiceErrorCapture(
  lazyPipe(async (): Promise<CheckCurationCreatableServiceResponse> => {
    const response = await getCurationsCheckLimit();

    return {
      isCreatable: response.data.canCreate,
    };
  }, validateServiceResponse(CheckCurationCreatableServiceResponseSchema)),
);
